/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { types } from 'mobx-state-tree';

const DELAY = 250;

export default types
	.model('RelationshipVisViewModel', {
		lastVisValid: types.optional(types.boolean, true),
		setTargetHandle: types.optional(types.union(types.number, types.null), null)
	})
	.volatile(() => ({
		target: null
	}))
	.actions((self) => ({
		setLastVisValid(valid) {
			self.lastVisValid = valid;
		},
		setContextMenuTarget(target) {
			if(self.setTargetHandle) {
				clearTimeout(self.setTargetHandle);
				self.setTargetHandle = null;
			}
			self.target = null;
			if(target) {
				self.setTargetHandle = setTimeout(() => self._setTarget(target), DELAY);
			}
		},
		_setTarget(target) {
			self.target = target;
			self.setTargetHandle = null;
		}
	}));



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/RelationshipWidgetViewModel.js